const SDK_VERSION = '7.47.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
